export const environment = {
  production: true,
  complexityMaxHours: 87600,
  colors: {
    primary: "#546e7a",
    secondary: "#78909c"
  },
  estimativaUrl: '/estimator/estimate',
  tecnologiasUrl: '/backoffice/technology',
  projectUrl: '/backoffice/project',
  addTech: '/backoffice/technology',
  projectRiskUrl: '/backoffice/riskItem',
  projectTypeUrl: '/backoffice/backofficeItem/projectType',
  documentationUrl: '/backoffice/backofficeItem/documentation',
  configurationUrl: '/backoffice/backofficeItem/configuration',
  parameterUrl: '/backoffice/backofficeItem/parameter',
  macroActivitiesUrl: '/backoffice/backofficeItem/macroActivity',
  actionTypeItemUrl: '/backoffice/backofficeItem/actionType',
  backofficeItemUrl: '/backoffice/backofficeItem',
  actionItemUrl: '/backoffice/actionItem/',
  calculateUrl: '/estimator/calculator/calculate',
  excelUrl: '/estimator/calculator/excel',
  excelToJiraUrl: '/calculator/excelToJira',
  authUrl: '/estimator/auth',
  auth2Url: '/estimator/auth',
  gcmUrl: '/backoffice/gcm',
  usersManagementUrl: '/backoffice/users',
  tenantsUrl: '/backoffice/tenants',
  technologiesManagementUrl: '/backoffice/technology',
  alertMessageUrl: '/backoffice/alertmessage',
  weeklyExcelUrl: '/calculator/weeklyExcel',
  manualUrl: '/estimator/calculator/manual',
  calculateAssociationUrl: '/estimator/calculator/calculate/association',
  authentication: '/estimator/auth',
  catalogUrl: '/backoffice/catalog',
  profileUrl: '/backoffice/profile',
  versionUrl: '/backoffice/version',
  permissionsUrl : '/backoffice/permissions',
  notificationsUrl: '/backoffice/notifications',
  ssoUrl: '',
  defaultTenantId: 'atos'
};
